import { Text, Strong as ReactStrong } from "@radix-ui/themes";

const Strong: React.FC<{
  children?: React.ReactNode;
  id?: string | undefined;
  isColoured?: boolean | undefined;
}> = ({ children, isColoured }) => {
  return (
    <Text color={isColoured ? "indigo" : undefined}>
      <ReactStrong>{children}</ReactStrong>
    </Text>
  );
};

export default Strong;
